/* FB | Urun ana gorsel HOVER ZOOM (buyutec) - SADECE PC (mouse). Mobile'a HIC dokunmaz.
   v10: Zoom SADECE sayfa TAMAMEN yuklendikten sonra calisir (document.readyState==='complete') -> yukleme
   sirasinda hover'da zoom devreye girip donma yapmaz. Panel SABIT (gorselin sagina, +80), 300 kare,
   object-fit farkinda (gerilme yok), adaptif zoom, currentSrc (beyaz panel yok), rAF throttle. */
(function(){
  'use strict';
  if(window.__fbProductZoom) return; window.__fbProductZoom=true;
  var MQ = (window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null);
  var ZOOM=3.5, SIZE=300, OFFSET_Y=80, MAXUP=1.25, panel=null, lastX=0, lastY=0, lastT=null, raf=0;

  function ensurePanel(){ if(panel) return panel; panel=document.createElement('div'); panel.className='fb-zoom-panel'; panel.style.cssText='position:fixed;z-index:99999;pointer-events:none;display:none;width:'+SIZE+'px;height:'+SIZE+'px;border:1px solid rgba(57,43,28,.22);box-shadow:0 12px 36px rgba(40,28,16,.28);border-radius:6px;background-color:#fff;background-repeat:no-repeat;'; document.body.appendChild(panel); return panel; }
  function hide(){ if(panel) panel.style.display='none'; }

  function process(){
    raf=0;
    var t=lastT;
    if(!t || !t.closest || !t.closest('media-gallery')){ hide(); return; }
    if(t.closest('slideshow-controls, slideshow-arrows, .slideshow-controls__thumbnail')){ hide(); return; }
    var slide=t.closest('slideshow-slide, .product-media-container');
    if(!slide){ hide(); return; }
    var img=slide.querySelector('img.product-media__image') || slide.querySelector('.product-media img') || slide.querySelector('img');
    if(!img){ hide(); return; }
    if(!img.complete || !img.naturalWidth){ hide(); return; }
    var src=img.currentSrc||img.src; if(!src){ hide(); return; }
    var rect=img.getBoundingClientRect();
    if(rect.width<20 || rect.height<20){ hide(); return; }
    var nw=img.naturalWidth, nh=img.naturalHeight;
    var of=getComputedStyle(img).objectFit, scl;
    if(of==='cover') scl=Math.max(rect.width/nw, rect.height/nh);
    else if(of==='none') scl=1;
    else if(of==='fill') scl=0;
    else scl=Math.min(rect.width/nw, rect.height/nh);
    var dw, dh, dx, dy;
    if(scl===0){ dw=rect.width; dh=rect.height; dx=rect.left; dy=rect.top; }
    else { dw=nw*scl; dh=nh*scl; dx=rect.left+(rect.width-dw)/2; dy=rect.top+(rect.height-dh)/2; }
    if(dw<20 || dh<20){ hide(); return; }
    var x=(lastX-dx)/dw, y=(lastY-dy)/dh;
    if(x<0||x>1||y<0||y>1){ hide(); return; }
    var z=ZOOM;
    if(nw){ var zmax=(nw*MAXUP)/dw; if(zmax<z) z=zmax; }
    if(z<1.3) z=1.3;
    var p=ensurePanel();
    var zoomW=dw*z, zoomH=dh*z;
    if(p.dataset.src!==src){ p.style.backgroundImage='url("'+src+'")'; p.dataset.src=src; }
    var bx=SIZE/2 - x*zoomW, by=SIZE/2 - y*zoomH;
    bx=Math.min(0, Math.max(SIZE-zoomW, bx)); by=Math.min(0, Math.max(SIZE-zoomH, by));
    p.style.backgroundSize=zoomW+'px '+zoomH+'px';
    p.style.backgroundPosition=bx+'px '+by+'px';
    var px = dx + dw + 16;
    if(px + SIZE > window.innerWidth - 8) px = window.innerWidth - 8 - SIZE;
    if(px < 8) px = 8;
    var py = rect.top + OFFSET_Y;
    if(py < 8) py = 8;
    if(py + SIZE > window.innerHeight - 8) py = window.innerHeight - 8 - SIZE;
    p.style.left = px+'px'; p.style.top = py+'px';
    p.style.display='block';
  }
  function onMove(e){
    if(document.readyState !== 'complete'){ hide(); return; }   /* sayfa yuklenene kadar zoom KAPALI -> donma yok */
    if(window.innerWidth < 750){ hide(); return; }
    if(MQ && !MQ.matches){ hide(); return; }
    lastX=e.clientX; lastY=e.clientY; lastT=e.target; if(!raf) raf=requestAnimationFrame(process);
  }
  if(!MQ || MQ.matches) document.addEventListener('mousemove', onMove, {passive:true});
  document.addEventListener('mouseleave', hide, {passive:true});
  window.addEventListener('scroll', hide, {passive:true});
  window.addEventListener('pagehide', hide, {passive:true});
  window.addEventListener('pageswap', hide, {passive:true});
  window.addEventListener('beforeunload', hide, {passive:true});
  document.addEventListener('visibilitychange', function(){ if(document.hidden) hide(); }, {passive:true});
})();